var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlueLogo = function SvgBlueLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 71 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#blue-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0093E2",
    d: "M51.667 0v14.65l-3.605.745v-4.542l-2.523 5.063-8.291 1.713V0h5.406v10.853L48.062 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5073DC",
    d: "M14.417 0v8.066l-3.604 2.418V0zM5.408 0v14.112L0 17.739V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0093E2",
    d: "M16.226 16.275V21.7h-.003v.266l-2.77.572-.835-.838H0v-3.964l5.408-3.628v3.975h5.409v-7.602l3.605-2.419v8.212zM62.848 0c-3.605 0-7.207 1.81-7.207 7.236v6.586l5.406-1.12V7.236c0-1.81 1.822-3.62 3.604-3.62h1.804v7.982l3.6-.745V7.236c0-5.427-3.6-7.236-7.207-7.236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5073DC",
    d: "M70.052 10.854v3.616c0 5.427-3.605 7.234-7.212 7.234-1.804 0-3.605-.45-4.955-1.58-1.349-1.13-2.252-2.94-2.252-5.654v-.637l5.406-1.12v5.377h1.8c1.784 0 3.608-1.81 3.608-3.62V11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0093E2",
    d: "M26.447 18.091h-1.802V7.241c0-1.81 1.823-3.62 3.605-3.62h1.801v3.62h3.608c0-5.427-3.608-7.237-7.212-7.237l-6.869 4.608a9.5 9.5 0 0 0-.341 2.634v7.226c0 3.245 1.287 5.195 3.093 6.24l10.37-2.141c.6-1.054.956-2.395.956-4.1h-3.605c0 1.81-1.822 3.62-3.604 3.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5073DC",
    d: "M26.448.004 19.58 4.612C20.56 1.21 23.503.004 26.448.004M51.663 14.649v7.054H48.06v-6.309zM45.54 15.918l-2.886 5.788h-5.406V17.63zM32.703 18.57c-1.313 2.283-3.784 3.134-6.257 3.134a8.24 8.24 0 0 1-4.114-.993zM16.221 21.97v3.35l-2.77-2.78zM14.417 0v8.066l-3.604 2.418V0zM5.408 0v14.112L0 17.739V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5073DC",
    d: "M26.448.004 19.58 4.612C20.56 1.21 23.503.004 26.448.004"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "blue-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70.058v25.321H0z"
  })))));
};
export default SvgBlueLogo;